import { render, staticRenderFns } from "./Pacman.vue?vue&type=template&id=827a8d62&"
var script = {}
import style0 from "./Pacman.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports